var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M19.3239 3.93931L13.264 9.99986L19.3239 16.0601C20.2253 16.9619 20.2253 18.4225 19.3239 19.3243C18.8735 19.7746 18.2831 20 17.6929 20C17.1017 20 16.5112 19.775 16.0612 19.3243L9.99999 13.2633L3.93927 19.3242C3.48896 19.7746 2.89843 19.9999 2.30774 19.9999C1.71721 19.9999 1.12709 19.7749 0.676375 19.3242C-0.224999 18.4229 -0.224999 16.9621 0.676375 16.0601L6.73606 9.99981L0.676031 3.93931C-0.225344 3.03793 -0.225344 1.5769 0.676031 0.675521C1.57723 -0.225174 3.03738 -0.225174 3.93893 0.675521L9.99994 6.73607L16.0605 0.675521C16.9622 -0.225174 18.4225 -0.225174 19.3236 0.675521C20.2253 1.5769 20.2253 3.03793 19.3239 3.93931Z",
    fill: "#292F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.530322a10e7cc03999332c872d7f7a0b.svg";
export { ForwardRef as ReactComponent };